import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const ChatContext = createContext(null);

const newSessionId = () => 'sess-' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);

export function ChatProvider({ children }) {
  const [sessionId, setSessionId] = useState(newSessionId());
  const [messages, setMessages] = useState([]);
  const [sending, setSending] = useState(false);

  const addMessage = useCallback((msg) => {
    setMessages(prev => [...prev, msg]);
  }, []);

  const updateActionStatus = useCallback((msgId, status, result) => {
    setMessages(prev =>
      prev.map(m => m.id === msgId ? { ...m, action_status: status, action_result: result ?? m.action_result } : m)
    );
  }, []);

  const reset = useCallback(() => {
    setSessionId(newSessionId());
    setMessages([]);
    setSending(false);
  }, []);

  const value = useMemo(() => ({
    sessionId, messages, sending, addMessage, setSending, updateActionStatus, reset,
  }), [sessionId, messages, sending, addMessage, updateActionStatus, reset]);

  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
}

export function useChat() {
  const ctx = useContext(ChatContext);
  if (!ctx) throw new Error('useChat must be inside ChatProvider');
  return ctx;
}
